import React from 'react';
import createReactClass from 'create-react-class';
import moment from 'moment';

export default createReactClass({
  displayName: 'Root',
  getInitialState() {
    return {
      circle: this.props.circle,
      isCompany: this.props.isCompany,
    };
  },
  onError() {
    var updated = this.state.circle;
    updated.main_image_thumb = '/images/ja2/img_noimage.gif';
    this.setState({
      circle: updated,
    });
  },
  render() {
    var lastMessageFormatted = '';
    if (this.props.lastMessage) {
      var now = moment();
      var createdDay = moment(this.props.lastMessage.created_at);
      if (now.isSame(createdDay, 'days')) {
        lastMessageFormatted = createdDay.format('HH:mm');
      } else {
        lastMessageFormatted = createdDay.format('MM/DD');
      }
    }
    var isSelected = '';
    // var hasUnreadMessage = this.props.hasUnreadMessage;
    var unreadMessageCount =
      this.props.unreadMessageCount > 0 ? (
        <p className="badge--unread unread--message">
          {this.props.unreadMessageCount}
        </p>
      ) : (
        ''
      );
    // @context TGW-1769 Phase2 自分宛の未読メンション合計（全体宛+チャンネル宛、
    //   my_circle_list の unreadMentionCount）。0件は非表示
    var unreadMentionCount =
      this.props.unreadMentionCount > 0 ? (
        <p className="badge--mention unread--message">
          @{this.props.unreadMentionCount}
        </p>
      ) : (
        ''
      );
    // var unreadBadge;
    if (this.props.currentCircleId == this.state.circle.id) {
      isSelected = 'is-selected';
    } else {
      isSelected = '';
    }
    let messageRoomUri = this.state.isCompany
      ? '/companies/companies_messages/circle/' + this.state.circle.id
      : '/message/circle/' + this.state.circle.id;
    // unreadBadge = hasUnreadMessage ? (
    //   <div style={{ display: "flex" }}>
    //     <span
    //       className="badge g-color-white g-bg-red "
    //       style={{ fontSize: "8px" }}
    //     >
    //       未読
    //     </span>
    //   </div>
    // ) : (
    //   ""
    // );
    // return <a href={messageRoomUri} className={'block-member ' + isSelected} style={{display:'flex', flexDirection:'row', alignItems:'center' }}>
    //     <div style={{display:'flex', alignItems:'center'}}>
    //         <div className="icon-type1">
    //             <img src={this.state.circle.main_image_thumb} onError={this.onError}/>
    //         </div>
    //         <span className="txt-member">
    //             {this.state.circle.name}
    //         </span>
    //         {unreadBadge}
    //     </div>
    // </a>;

    return (
      <li>
        <a href={messageRoomUri} className={'hov--default ' + isSelected}>
          <div
            className={`row justify-content-around align-items-center pt-3 pb-3 ${
              this.props.isLast ? '' : 'border-bottom'
            }`}
          >
            <div className="col-2 pr-1">
              <img
                className="lazyload rounded-circle member-icon_48px"
                data-src={this.state.circle.main_image_thumb}
                onError={this.onError}
              />
            </div>
            <div className="col-8 pl-3 pr-2">
              <p
                className="mb-1 line-1 position-relative mr-4"
                style={{ overflow: 'scroll' }}
              >
                <span
                  className="badge badge-light"
                  style={{
                    fontWeight: this.props.unreadMessageCount > 0 ? 700 : 400,
                  }}
                >
                  {this.state.circle.name}
                </span>
              </p>
              <span className="position-absolute position--messagenum">
                ({this.state.circle.real_num_of_members})
              </span>
              <p className="text-fz-14px text-black-20 mb-0 line-2">
                {this.props.lastMessage ? this.props.lastMessage.body : ''}
              </p>
            </div>
            <div className="col-2 p-0 align-self-start">
              <p className="text-fz-small text-black-20 mb-0 text-center">
                {lastMessageFormatted}
              </p>
              {unreadMessageCount}
              {unreadMentionCount}
            </div>
          </div>
        </a>
      </li>
    );
  },
});
